<script setup lang="ts">
import { computed } from 'vue'
import { publicImageAttribution } from './image-attribution'
import type { WebsiteImage } from './types'

const props = defineProps<{ image: WebsiteImage }>()
const attribution = computed(() => publicImageAttribution(props.image))
</script>

<template>
  <span v-if="attribution" class="site:z-10 site:rounded-full site:bg-black/65 site:px-2.5 site:py-1 site:text-[10px] site:text-white/90 site:backdrop-blur-md">
    Photo by
    <a
      :href="attribution.photographerUrl"
      target="_blank"
      rel="noreferrer"
      class="site:underline site:underline-offset-2"
    >{{ attribution.photographer }}</a>
    on
    <a
      :href="attribution.providerUrl"
      target="_blank"
      rel="noreferrer"
      class="site:underline site:underline-offset-2"
    >{{ attribution.provider }}</a>
  </span>
</template>
